<template>
  <div class="m-4">
    <motion_button
      :while-hover="{ scale: 1.5, x: 30 }"
      :while-press="{ scale: 0.8 }"
      @click="delay_push"
      class="tw_btn_detail"
    >
      {{ btn_title }}
    </motion_button>
  </div>
</template>

<script>
// components\DetailButton.vue
import { motion } from "motion-v";
import { defineComponent } from "vue";
// import Vue from "vue";
// import { useRouter } from "vue-router";
// import { Icon } from "@iconify/vue";
import * as Helper from "@/helper";

export default defineComponent({
  name: "DetailButton",
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  components: {
    // "motion.button": motion.button,
    motion_button: motion.button,
    // Icon,
  },
  data: () => {
    // const router = useRouter();
    return {
      // router,
    };
  },
  computed: {
    btn_title() {
      if (this.to.indexOf("http") == 0) {
        return "LINK OPEN 🚀";
      }
      return "ENDTER";
    },
  },
  methods: {
    async delay_push() {
      const to = this.to;

      await Helper.wait(500);

      if (to.indexOf("http") == 0) {
        // 새창 열기
        window.open(to);
      } else {
        // 내부 주소
        this.$router.push(to);
      }
    },
  },
});
</script>

<style scoped>
.tw_btn_detail {
  @apply rounded-full border-2 px-4 py-2;
}
</style>
